// src/components/command.tsx
import { useSelector as useSelector2 } from "@xstate/store/react";
import { Command as Cmd } from "cmdk";
import React4 from "react";

// src/utils/store.ts
import { createStore } from "@xstate/store";

// src/types.ts
import "react";

// src/utils/store.ts
var slashStore = createStore(
  {
    query: "",
    range: null,
    localEditor: null
  },
  {
    setQuery: (_, event) => {
      return {
        query: event.query
      };
    },
    setRange: (_, event) => {
      return {
        range: event.range
      };
    },
    setLocalEditor: (_, event) => {
      return {
        localEditor: event.localEditor
      };
    }
  }
);
var store_default = slashStore;

// src/utils/tunnel.tsx
import React2 from "react";
import { createStore as createStore2 } from "@xstate/store";
import { useSelector } from "@xstate/store/react";

// src/utils/use-isomorphic-effect.ts
import * as React from "react";
var useIsoMorphicEffect = typeof window === "undefined" ? React.useEffect : React.useLayoutEffect;
var use_isomorphic_effect_default = useIsoMorphicEffect;

// src/utils/tunnel.tsx
var tunnel = () => {
  const tunnelStore = createStore2(
    {
      currentChildren: []
    },
    {
      addChildren: (context, event) => {
        return {
          currentChildren: [...context.currentChildren, event.value]
        };
      },
      removeChildren: (context, event) => {
        return {
          currentChildren: context.currentChildren.filter(
            (child) => child !== event.value
          )
        };
      }
    }
  );
  return {
    Inlet: (props) => {
      const { children } = props;
      use_isomorphic_effect_default(() => {
        tunnelStore.send({ type: "addChildren", value: children });
        return () => {
          tunnelStore.send({ type: "removeChildren", value: children });
        };
      }, [props.children]);
      return null;
    },
    Outlet: () => {
      const children = useSelector(
        tunnelStore,
        (state) => state.context.currentChildren
      );
      return /* @__PURE__ */ React2.createElement(React2.Fragment, null, children);
    }
  };
};
var tunnel_default = tunnel;

// src/components/tunnel-instance.tsx
import React3 from "react";
var SlashCmdTunnelInstanceContext = React3.createContext(
  null
);
var tunnel_instance_default = SlashCmdTunnelInstanceContext;

// src/utils/constants.ts
var SLASH_EXTENSION_NAME = "slash-menu";
var SLASH_EXTENSION_DOM_ID = "slash-extenbsion-dom-id";
var navigationKeys = ["ArrowUp", "ArrowDown", "Enter"];

// src/components/command.tsx
var Command = React4.forwardRef((props, ref) => {
  const { children, className, ...restProps } = props;
  const { query } = useSelector2(store_default, (state) => state.context);
  const onChange = (query2) => {
    store_default.send({
      type: "setQuery",
      query: query2
    });
  };
  return /* @__PURE__ */ React4.createElement(tunnel_instance_default.Consumer, null, (tunnel3) => {
    if (!tunnel3) {
      throw new Error(
        "Command component must be used within a <SlashProvider/>. Make sure your instance of editor and command are wrapped in the provider"
      );
    }
    return /* @__PURE__ */ React4.createElement(tunnel3.Inlet, null, /* @__PURE__ */ React4.createElement(
      Cmd,
      {
        ...restProps,
        ref,
        onKeyDown: (e) => e.stopPropagation(),
        className,
        id: SLASH_EXTENSION_DOM_ID
      },
      /* @__PURE__ */ React4.createElement(
        Cmd.Input,
        {
          value: query,
          onValueChange: onChange,
          style: { display: "none" }
        }
      ),
      children
    ));
  });
});
Command.displayName = "SlashCommand";
var command_default = Command;

// src/components/item.tsx
import "@tiptap/react";
import React5 from "react";
import { CommandItem } from "cmdk";
import { useSelector as useSelector3 } from "@xstate/store/react";
var Item = React5.forwardRef((props, ref) => {
  const { onCommand, className, children, ...restProps } = props;
  const { range, localEditor } = useSelector3(
    store_default,
    (state) => state.context
  );
  if (!localEditor) {
    throw new Error(
      "Editor is required, Please provide editor to the Cmd.Root or use within EditorProvider."
    );
  }
  if (!range) {
    return null;
  }
  return /* @__PURE__ */ React5.createElement(
    CommandItem,
    {
      ...restProps,
      onSelect: () => onCommand({ editor: localEditor, range }),
      ref,
      className
    },
    children
  );
});
Item.displayName = "SlashItem";
var item_default = Item;

// src/components/root.tsx
import { useCurrentEditor as useCurrentEditor2 } from "@tiptap/react";
import React6, { useEffect as useEffect2 } from "react";
var SlashCmdRoot = (props) => {
  const { children, editor: propEditor } = props;
  const { editor: contextEditor } = useCurrentEditor2() || {};
  const editor = propEditor || contextEditor;
  useEffect2(() => {
    if (editor) {
      store_default.send({
        type: "setLocalEditor",
        localEditor: editor
      });
    }
  }, [editor]);
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, children);
};
var root_default = SlashCmdRoot;

// src/components/index.tsx
import { Command as Cmd2 } from "cmdk";
var SlashCommand = {
  Root: root_default,
  Cmd: command_default,
  List: Cmd2.List,
  Item: item_default,
  Empty: Cmd2.Empty,
  Loading: Cmd2.Loading,
  Separator: Cmd2.Separator,
  Group: Cmd2.Group
};
var components_default = SlashCommand;

// src/components/slash-provider.tsx
import React7 from "react";
var SlashCmdProvider = (props) => {
  const tunnelInstance = React7.useRef(tunnel_default()).current;
  return /* @__PURE__ */ React7.createElement(tunnel_instance_default.Provider, { value: tunnelInstance }, props.children);
};
var slash_provider_default = SlashCmdProvider;

// src/extensions/suggestions.ts
var createSuggestionsItems = (items) => {
  return items;
};
var suggestions_default = createSuggestionsItems;

// src/extensions/slash-extension.ts
import { Extension } from "@tiptap/react";
import Suggestion from "@tiptap/suggestion";

// src/extensions/render-items.ts
import "react";
import { ReactRenderer } from "@tiptap/react";
import tippy from "tippy.js";

// src/components/command-outlet.tsx
import React8 from "react";
var CommandTunnelOutlet = (props) => {
  React8.useEffect(() => {
    store_default.send({
      type: "setQuery",
      query: props.query
    });
  }, [props.query]);
  React8.useEffect(() => {
    store_default.send({
      type: "setRange",
      range: props.range
    });
  }, [props.range]);
  React8.useEffect(() => {
    const abortController = new AbortController();
    document.addEventListener(
      "keydown",
      (event) => {
        if (navigationKeys.includes(event.key)) {
          event.preventDefault();
          const slashCommandRef = document.getElementById(
            SLASH_EXTENSION_DOM_ID
          );
          if (slashCommandRef) {
            slashCommandRef.dispatchEvent(
              new KeyboardEvent("keydown", {
                key: event.key,
                cancelable: true,
                bubbles: true
              })
            );
            return false;
          }
        }
      },
      {
        signal: abortController.signal
      }
    );
    return () => {
      abortController.abort();
    };
  }, []);
  return /* @__PURE__ */ React8.createElement(tunnel_instance_default.Consumer, null, (tunnelInstance) => {
    if (!tunnelInstance) {
      throw new Error(
        "Command component must be used within a <SlashProvider/>. Make sure your instance of editor and command are wrapped in the provider"
      );
    }
    return /* @__PURE__ */ React8.createElement(tunnelInstance.Outlet, null);
  });
};
var command_outlet_default = CommandTunnelOutlet;

// src/extensions/render-items.ts
var renderItems = (elementRef) => {
  let component = null;
  let popup = null;
  return {
    onStart: (props) => {
      const { editor, clientRect } = props;
      component = new ReactRenderer(command_outlet_default, {
        editor,
        props
      });
      const { selection } = editor.state;
      const parentNode = selection.$from.node(selection.$from.depth);
      const blockType = parentNode.type.name;
      if (blockType === "codeBlock") {
        return false;
      }
      popup = tippy("body", {
        getReferenceClientRect: props.clientRect,
        appendTo: () => elementRef ? elementRef.current : document.body,
        content: component.element,
        showOnCreate: true,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start"
      });
    },
    onUpdate: (props) => {
      component?.updateProps(props);
      popup?.[0]?.setProps({
        // @ts-ignore
        getReferenceClientRect: props.clientRect
      });
    },
    onKeyDown: (props) => {
      if (props.event.key === "Escape") {
        popup?.[0]?.hide();
        return true;
      }
      return component?.ref?.onKeyDown(props);
    },
    onExit: () => {
      popup?.[0]?.destroy();
      component?.destroy();
    }
  };
};
var render_items_default = renderItems;

// src/extensions/slash-extension.ts
var slashExtenstionSuggestion = Extension.create({
  name: SLASH_EXTENSION_NAME,
  addOptions() {
    return {
      suggestion: {
        char: "/",
        command: ({ editor, range, props }) => {
          props.command({ editor, range });
        },
        render: render_items_default
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion
      })
    ];
  }
});
var slash_extension_default = slashExtenstionSuggestion;

// src/extensions/helper.ts
var enableKeyboardNavigation = (event) => {
  if (navigationKeys.includes(event.key)) {
    const slashCommand = document.getElementById(SLASH_EXTENSION_DOM_ID);
    if (slashCommand) {
      return true;
    }
  }
};
export {
  slash_extension_default as Slash,
  components_default as SlashCmd,
  slash_provider_default as SlashCmdProvider,
  suggestions_default as createSuggestionsItems,
  enableKeyboardNavigation,
  render_items_default as renderItems
};
